import { render, staticRenderFns } from "./BookingsBilling.vue?vue&type=template&id=db33815c&"
import script from "./BookingsBilling.vue?vue&type=script&lang=js&"
export * from "./BookingsBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports